<template>
  <el-dialog title="修改企业简称" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="企业简称:">
          <el-input v-model="form.name" placeholder="请输入企业简称"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    name: "enterpriseAddressDialog",
    props: ["visible", "formData"],
    watch: {
      formData: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      },
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:formData', this.form)
    },
    created() {
      this.form = this.formData
    },
    data() {
      return {
        dialogVisible: this.visible,
        form: {},
        options: []
      };
    },
    methods: {
      onSubmit() {
        if (!this.form.name) {
          this.$message.error('请填写企业简称');
          return
        }
        this.$emit('editFrom');
      }
    }
  };
</script>

